function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Groupe_3274",
  "data-name": "Groupe 3274",
  transform: "translate(-12747 2668.574)"
}, React.createElement("g", {
  id: "like",
  transform: "translate(12747 -2668.574)"
}, React.createElement("path", {
  id: "Trac\\xE9_1914",
  "data-name": "Trac\\xE9 1914",
  d: "M219.145,102.995h-17.83a2.061,2.061,0,0,1-1.049-3.836c7.768-4.59,11.8-9.945,12.336-16.369a4.431,4.431,0,0,1,4.426-3.981,8.713,8.713,0,0,1,8.576,8.709h0v.693c0,5.624-1.666,9.21-4.739,13.86A2.062,2.062,0,0,1,219.145,102.995Z",
  transform: "translate(-173.08 -67.997)",
  fill: "#fdd44f"
}), React.createElement("path", {
  id: "Trac\\xE9_1915",
  "data-name": "Trac\\xE9 1915",
  d: "M187.177,231.542a6.466,6.466,0,0,0-6.459-6.459H147.5a2.06,2.06,0,0,0-1.049.287c-2.332,1.379-4.687,2.514-6.579,3.426-.66.318-1.283.619-1.85.9a2.061,2.061,0,0,0-1.139,1.844v26.386a2.062,2.062,0,0,0,1.139,1.844c8.329,4.164,15.253,4.668,23.327,4.668,1.25,0,2.529-.012,3.844-.024,1.454-.014,2.958-.028,4.534-.028h6.517a6.457,6.457,0,0,0,5.561-9.741,6.454,6.454,0,0,0,2.2-8.8,6.452,6.452,0,0,0,1.406-9.865A6.414,6.414,0,0,0,187.177,231.542Z",
  transform: "translate(-119.262 -194.209)",
  fill: "#fdd44f"
}), React.createElement("g", {
  id: "Groupe_3271",
  "data-name": "Groupe 3271",
  transform: "translate(26.386 0)"
}, React.createElement("path", {
  id: "Trac\\xE9_1916",
  "data-name": "Trac\\xE9 1916",
  d: "M431.674,115.184h-4.4a2.061,2.061,0,0,1,0-4.123h4.4a2.061,2.061,0,1,1,0,4.123Z",
  transform: "translate(-394.432 -95.827)",
  fill: "#29ccb1"
}), React.createElement("path", {
  id: "Trac\\xE9_1917",
  "data-name": "Trac\\xE9 1917",
  d: "M207.255,115.184h-4.4a2.061,2.061,0,1,1,0-4.123h4.4a2.061,2.061,0,0,1,0,4.123Z",
  transform: "translate(-200.796 -95.827)",
  fill: "#29ccb1"
}), React.createElement("path", {
  id: "Trac\\xE9_1918",
  "data-name": "Trac\\xE9 1918",
  d: "M269.177,7.933A2.06,2.06,0,0,1,267.39,6.9l-2.2-3.808a2.061,2.061,0,1,1,3.57-2.061l2.2,3.808a2.062,2.062,0,0,1-1.783,3.092Z",
  transform: "translate(-256.12 -0.001)",
  fill: "#29ccb1"
}), React.createElement("path", {
  id: "Trac\\xE9_1919",
  "data-name": "Trac\\xE9 1919",
  d: "M379.183,7.932A2.062,2.062,0,0,1,377.4,4.84l2.2-3.808a2.061,2.061,0,0,1,3.57,2.061L380.97,6.9A2.06,2.06,0,0,1,379.183,7.932Z",
  transform: "translate(-352.936 0)",
  fill: "#29ccb1"
})), React.createElement("path", {
  id: "SVGCleanerId_0",
  d: "M76.68,419.693V430.55H72.557V419.693a2.061,2.061,0,1,1,4.123,0Z",
  transform: "translate(-63.762 -360.346)",
  fill: "#73c3ff"
}), React.createElement("g", {
  id: "Groupe_3272",
  "data-name": "Groupe 3272",
  transform: "translate(26.386 0)"
}, React.createElement("path", {
  id: "Trac\\xE9_1920",
  "data-name": "Trac\\xE9 1920",
  d: "M431.674,115.184h-4.4a2.061,2.061,0,0,1,0-4.123h4.4a2.061,2.061,0,1,1,0,4.123Z",
  transform: "translate(-394.432 -95.827)",
  fill: "#ff8e70"
}), React.createElement("path", {
  id: "Trac\\xE9_1921",
  "data-name": "Trac\\xE9 1921",
  d: "M207.255,115.184h-4.4a2.061,2.061,0,1,1,0-4.123h4.4a2.061,2.061,0,0,1,0,4.123Z",
  transform: "translate(-200.796 -95.827)",
  fill: "#ff8e70"
}), React.createElement("path", {
  id: "Trac\\xE9_1922",
  "data-name": "Trac\\xE9 1922",
  d: "M269.177,7.933A2.06,2.06,0,0,1,267.39,6.9l-2.2-3.808a2.061,2.061,0,1,1,3.57-2.061l2.2,3.808a2.062,2.062,0,0,1-1.783,3.092Z",
  transform: "translate(-256.12 -0.001)",
  fill: "#ff8e70"
}), React.createElement("path", {
  id: "Trac\\xE9_1923",
  "data-name": "Trac\\xE9 1923",
  d: "M379.183,7.932A2.062,2.062,0,0,1,377.4,4.84l2.2-3.808a2.061,2.061,0,0,1,3.57,2.061L380.97,6.9A2.06,2.06,0,0,1,379.183,7.932Z",
  transform: "translate(-352.936 0)",
  fill: "#ff8e70"
})), React.createElement("g", {
  id: "Groupe_3273",
  "data-name": "Groupe 3273",
  transform: "translate(8.795 57.286)"
}, React.createElement("path", {
  id: "SVGCleanerId_0_1_",
  d: "M76.68,419.693V430.55H72.557V419.693a2.061,2.061,0,1,1,4.123,0Z",
  transform: "translate(-72.557 -417.632)",
  fill: "#73c3ff"
})), React.createElement("path", {
  id: "Trac\\xE9_1924",
  "data-name": "Trac\\xE9 1924",
  d: "M28.09,225.083H10.5a2.062,2.062,0,0,0-2.061,2.061v35.181a2.1,2.1,0,0,0,2.061,2.087H23.692a6.534,6.534,0,0,0,5.779-3.6,6.4,6.4,0,0,0,.68-2.882V227.144A2.062,2.062,0,0,0,28.09,225.083Z",
  transform: "translate(-8.438 -194.209)",
  fill: "#ce162b"
})));

var SvgLike = function SvgLike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 67.916,
    height: 70.231,
    viewBox: "0 0 67.916 70.231",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/like.3d70b081.svg";
export { ForwardRef as ReactComponent };